/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Leaveconfirm2Inputs */

const zh_organizationsettings_leaveconfirm2 = /** @type {(inputs: Organizationsettings_Leaveconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离开`)
};

const en_organizationsettings_leaveconfirm2 = /** @type {(inputs: Organizationsettings_Leaveconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave`)
};

const es_organizationsettings_leaveconfirm2 = /** @type {(inputs: Organizationsettings_Leaveconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonar`)
};

/**
* | output |
* | --- |
* | "Leave" |
*
* @param {Organizationsettings_Leaveconfirm2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_leaveconfirm2 = /** @type {((inputs?: Organizationsettings_Leaveconfirm2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Leaveconfirm2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_leaveconfirm2(inputs)
	if (locale === "en") return en_organizationsettings_leaveconfirm2(inputs)
	return es_organizationsettings_leaveconfirm2(inputs)
});
export { organizationsettings_leaveconfirm2 as "organizationSettings_leaveConfirm" }